import React from 'react'
import { Outlet, Link } from 'react-router-dom'
import { MyContainer } from '@/components/common'
import NavbarV2 from '@/components/specific/v2/NavbarV2'

function BaseV2() {
  return (
    <div className="flex flex-col relative min-h-screen drawer overflow-x-hidden">
      <input id="drawer-v2" type="checkbox" className="drawer-toggle" />
      
      {/* Navbar */}
      <NavbarV2 />
      
      {/* Main Content */}
      <MyContainer className="flex-grow gap-8 drawer-content">
        <Outlet />
      </MyContainer>

      {/* Mobile Drawer */}
      <div className="drawer-side z-[200]">
        <label htmlFor="drawer-v2" aria-label="close sidebar" className="drawer-overlay z-[199]"></label>
        {/* <ul 
          className="menu p-4 w-80 bg-base-100 text-base-content min-h-full shadow-lg z-[200]"
          style={{
            minHeight: 'calc(100vh - 64px)',
            marginTop: 64
          }}
        >
          <li>
            <Link to="/v2/info-tagihan" className="text-gray-700">Home</Link>
          </li>
          <li>
            <Link to="/v2/info-tagihan" className="text-gray-700">Info Tagihan</Link>
          </li>
          <li>
            <Link to="/v2/info-tagihan" className="text-gray-700">Riwayat Pembayaran</Link>
          </li>
          <li>
            <Link to="/v2/info-tagihan" className="text-gray-700">Bantuan</Link>
          </li>
          <li className="divider my-1"></li>
          <li>
            <Link to="/v2/info-tagihan" className="text-gray-700">Tentang Kami</Link>
          </li>
        </ul> */}
      </div>

      {/* Footer */}
      <footer className="footer mt-auto footer-center bg-gray-50 text-gray-600 p-4 border-t border-gray-200">
        <aside>
          <p className="text-sm">Copyright © {new Date().getFullYear()} - Tim IT Perumda Air Minum Cilegon Mandiri</p>
        </aside>
      </footer>
    </div>
  )
}

export default BaseV2

